import { useDispatch, useSelector } from "react-redux";
import {
  AnalyticsTypeMap,
  LOCATION_MAP,
  MARKETS_VIEW,
} from "../../../../constants";
import FilterCategory from "../FilterCategory";
import FilterSelection from "../../../../experiments/BubbleJourney/components/FilterSelection";
import styles from "./FilterMarkets.module.scss";
import { sendAnalyticsEvent } from "../../../../lib/postMessage";
import FilterSelectionLoadingSkeleton from "../../../../components/FilterSelectionLoadingSkeleton";
import {
  addMarketsAndUpdateFilter,
  removeMarketsAndUpdateFilter,
} from "../../../../actions/filters";
import { DESELECT, FILTERS, SELECT } from "../../../../constants/analytics";

export default function FilterMarkets({ marketGroups }) {
  const dispatch = useDispatch();
  const { prefetchedFilters } = useSelector((state) => state.filter);
  const { activeView } = useSelector((state) => state.view);

  function handleMarketSelection(market) {
    const analyticsEvent = {
      event: FILTERS,
      type: AnalyticsTypeMap.get(MARKETS_VIEW) ?? MARKETS_VIEW,
      location: LOCATION_MAP.get(activeView) || "",
    };
    if (prefetchedFilters.markets.includes(market.type)) {
      dispatch(removeMarketsAndUpdateFilter(market.type));
      sendAnalyticsEvent({
        ...analyticsEvent,
        action: DESELECT,
        value: market.name,
      });
    } else {
      dispatch(addMarketsAndUpdateFilter(market.type));
      sendAnalyticsEvent({
        ...analyticsEvent,
        action: SELECT,
        value: market.name,
      });
    }
  }

  return (
    <div className={styles.marketsSelections}>
      {marketGroups.map((marketGroup) => (
        <FilterCategory
          key={marketGroup._id}
          categoryName={marketGroup.name}
          selections={marketGroup.markets}
          logoUrl={marketGroup.logoUrl}
          activeFilterView={MARKETS_VIEW}
        >
          {marketGroup.markets.map((market) => (
            <FilterSelection
              key={market._id}
              onClick={() => handleMarketSelection(market)}
              checked={prefetchedFilters.markets.includes(market.type)}
              showCheckbox
              label={market.name}
            >
              <FilterSelectionLoadingSkeleton
                skeletonKey={market.type}
                textBlocks={1}
              />
              <div>
                <h4>{market.name}</h4>
              </div>
            </FilterSelection>
          ))}
        </FilterCategory>
      ))}
    </div>
  );
}
